"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStorybookFigmaAddon = void 0;
var useStorybookFigmaAddon = function (link) {
    if (!link)
        return;
    var url = link.startsWith('http')
        ? link
        : "https://www.figma.com/file/KLWxYdHAdFNvmt4WjEbCid/?node-id=" + link;
    return {
        design: {
            type: 'figma',
            url: url,
        },
    };
};
exports.useStorybookFigmaAddon = useStorybookFigmaAddon;
//# sourceMappingURL=useStorybookFigmaAddon.js.map